<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.order-list')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12" >
        <b-card class="mb-4">
          <b-row>
            <b-colxx xxs="12" md="6" lg="4" xxl="3">
              <div class="form-group has-float-label">
                <b-input-group>
                  <v-date-picker
                    mode="single"
                    v-model="startDate"
                    :max-date="endDate"
                    :input-props="{ class:'form-control', placeholder: '' }"></v-date-picker>
                  <template v-slot:append>
                    <b-input-group-text>
                      <b-icon icon="calendar"></b-icon>
                    </b-input-group-text>
                  </template>
                </b-input-group>
                <span>시작날짜</span>
              </div>
            </b-colxx>
            <b-colxx xxs="12" md="6" lg="4" xxl="3">
              <div class="form-group has-float-label">
                <b-input-group>
                  <v-date-picker
                    mode="single"
                    v-model="endDate"
                    :min-date="startDate"
                    :input-props="{ class:'form-control', placeholder: ''}"></v-date-picker>
                  <template v-slot:append>
                    <b-input-group-text>
                      <b-icon icon="calendar"></b-icon>
                    </b-input-group-text>
                  </template>
                </b-input-group>
                <span>종료날짜</span>
              </div>
            </b-colxx>
            <b-colxx xxs="12" md="12" lg="4" class="mb-3">
              <b-button variant="primary" @click="searchData">검색</b-button>
              <download-excel :fetch="fetchData" class="btn btn-outline-success" :fields="fields"
                              :name="`couponList${endDate}.xls`">Excel
              </download-excel>
            </b-colxx>
          </b-row>
          <b-row>
            <b-colxx xxs="12" class="mb-4">
              <h6 class="card-subtitle">주문현황차트</h6>
              <order_line_chart v-if="isLoad" ref="order_chart" :chart-data="ChartData" :height="500"/>
            </b-colxx>
          </b-row>
          <b-row>
            <b-colxx xxs="12">
              <b-table
                head-variant="light"
                ref="general-table"
                class="vuetable"
                id="table-transition-example"
                :items="items"
                align="center"
                :fields="fields"
                primary-key="bookingId"
                responsive
                show-empty>
                <template v-slot:empty>
                  <h3 style="text-align:center">검색된 데이터가 없습니다.</h3>
                </template>
              </b-table>
            </b-colxx>
          </b-row>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  import api from '../../constants/api'
  import OrderLineChart from './components/OrderChart'
  import {alignTableCenter, ThemeColors} from '../../utils'

  const colors = ThemeColors()
  const chartOption = {
    pointBackgroundColor: colors.foregroundColor,
    pointHoverBorderColor: colors.foregroundColor,
    pointRadius: 6,
    pointBorderWidth: 2,
    pointHoverRadius: 8,
    fill: false
  }

  export default {
    components: {
      'order_line_chart': OrderLineChart
    },

    data() {
      return {
        isLoad: false,
        startDate: this.$moment().subtract(7,'day').toDate(),
        endDate: this.$moment().toDate(),
        ChartData: null,
        fields: [
          {key: "date", label: "날짜", ...alignTableCenter},
          {key: "online", label: "온라인", ...alignTableCenter},
          {key: "channel", label: "외부채널", ...alignTableCenter},
          {key: "summary", label: "합계", ...alignTableCenter},
        ],
        items : []
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
      this.searchData()
    },
    methods: {
      drawChat(data) {

        let chart_data = this.pivot(data)
        this.ChartData = {
          labels: chart_data.date,
          datasets: [{
            label: '온라인',
            data: chart_data.online,
            borderColor: colors.themeColor1,
            pointBorderColor: colors.themeColor1,
            pointHoverBackgroundColor: colors.themeColor1,
            ...chartOption
          },
            {
              label: '외부채널',
              data: chart_data.channel,
              borderColor: colors.themeColor2,
              pointBorderColor: colors.themeColor2,
              pointHoverBackgroundColor: colors.themeColor2,
              ...chartOption
            },
            {
              label: '합계',
              data: chart_data.summary,
              borderColor: colors.primaryColor,
              pointBorderColor: colors.primaryColor,
              pointHoverBackgroundColor: colors.primaryColor,
              ...chartOption
            }]
        }

      },
      fetchData(){
        return this.items
      },
      searchData() {
        this.isLoad = false
        // const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order)
        // const params = {}

        // this.$http.get(reqURL, {
        //   params: params,
        //   headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        // }).then(res => {
        //   if (res.data.code === "OK") {
        //   } else {
        //     throw 400
        //   }
        // }).catch(err => {
        // })

        this.items =  [
          {date: '2020-03-02', online: 10, channel: 20, summary: 30},
          {date: '2020-03-03', online: 20, channel: 30, summary: 50},
          {date: '2020-03-04', online: 30, channel: 20, summary: 50},
          {date: '2020-03-05', online: 20, channel: 20, summary: 40},
          {date: '2020-03-05', online: 20, channel: 20, summary: 40},
        ]

        this.drawChat(this.items)
        this.isLoad = true
      }
      , getRandomInt() {
        // JS function to generate numbers to be used for the chart
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      excelDown() {

      },
      pivot(data) {
        let iter = function (pivoted, record) {
          for (let key in record) {
            if (!pivoted[key]) pivoted[key] = []
            pivoted[key].push(record[key])
          }
          return pivoted;
        }
        return data.reduce(iter, {})
      }

    }
    , watch: {}
  }
</script>
